import React from "react";
import { Alert, AlertTitle } from "@mui/material";

const AccessNotAllowed: React.FC = () => {
  return (
    <Alert severity="error">
      <AlertTitle>Access Not Allowed</AlertTitle>
      Sorry, you do not have permission to access this page.
    </Alert>
  );
};

export default AccessNotAllowed;
